export const contentTranslationEndpoints = {
  /** This endpoint, which includes a JSON Web Token, is set in static embedding */
  getDictionary: null as string | null,
  uploadDictionary: "/api/ee/content-translation/upload-dictionary",
  getCSV: "/api/ee/content-translation/csv",
};
